import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-simios-light/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Image/Graphic Side */}
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-simios-accent to-blue-600 rounded-lg blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200"></div>
            <div className="relative px-7 py-6 bg-simios-dark ring-1 ring-gray-900/5 rounded-lg leading-none flex items-top justify-start space-x-6 h-full min-h-[400px]">
               <img 
                  src="simon.jpg" 
                  onError={(e) => {
                    e.currentTarget.src = "https://picsum.photos/id/1/800/800"; // Fallback if file not found
                  }}
                  alt="Simon Loftus" 
                  className="w-full h-full object-cover rounded shadow-lg filter grayscale hover:grayscale-0 transition-all duration-500"
               />
            </div>
            {/* Tech Decoration */}
             <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-simios-accent/10 border border-simios-accent/30 rounded-full flex items-center justify-center">
                <div className="text-simios-accent font-mono text-xs">EST. 2024</div>
             </div>
          </div>

          {/* Text Content */}
          <div>
            <h2 className="text-3xl font-extrabold text-white sm:text-4xl mb-6">
              Meet the Founder
            </h2>
            <div className="w-20 h-1 bg-simios-accent mb-8"></div>
            
            <h3 className="text-xl text-simios-accent font-semibold mb-2">Simon Loftus</h3>
            <p className="text-sm text-gray-400 mb-6 italic">
              "Without failures, we don't learn and progress."
            </p>

            <div className="space-y-4 text-simios-muted text-lg leading-relaxed mb-8">
              <p>
                I am a serial entrepreneur with a diverse portfolio of ventures established in both <strong>Mexico and the UK</strong>. My journey has been defined by resilience and learning, believing deeply that true progress comes from navigating both successes and setbacks.
              </p>
              <p>
                Currently, I bridge multiple worlds: serving as <strong>Principal Product Manager at 10x Banking</strong> within the fintech space, and as <strong>Managing Director</strong> of a residential property management company.
              </p>
              <p>
                My leadership experience extends to community governance, having previously served as a <strong>School Governor</strong> for a nursery, where I navigated challenging financial landscapes and government budget constraints. Simios brings this multifaceted resilience and strategic depth to your business.
              </p>
            </div>

            <ul className="space-y-3">
              {[
                "Serial Entrepreneur (UK & Mexico)",
                "Principal Product Manager (Fintech)",
                "Managing Director (Property Management)",
                "Strategic Board Advisory"
              ].map((item, index) => (
                <li key={index} className="flex items-center text-gray-300">
                  <svg className="h-5 w-5 text-simios-accent mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;